import PropTypes from "prop-types";
import React from "react";
import { injectIntl, intlShape } from "react-intl";
import { Link } from "react-router-dom";
import { Button, Toolbar, ToolbarSection } from "cxa-components";
import { CloseIcon } from "cxa-icons";

const Notification = ({
  id,
  dismissable,
  target,
  messageDescription,
  messageValue,
  link,
  linkTextDescription,
  linkTextValue,
  handleOnClick,
  intl,
}) =>
  <article key={id} className="card">
    <section>
      <Toolbar>
        <ToolbarSection>
          <p>
            {intl.formatMessage(messageDescription, messageValue)}{" "}
            <Link to={link} target={target} className="cxa-c-action">
              <div dangerouslySetInnerHTML={{
                      __html: intl.formatMessage(linkTextDescription, linkTextValue),
                    }}
              />
            </Link>
          </p>
        </ToolbarSection>
        <ToolbarSection>
          {!!dismissable &&
            <Button type="button" tertiary icon onClick={handleOnClick}>
              <CloseIcon />
            </Button>}
        </ToolbarSection>
      </Toolbar>
    </section>
  </article>;

Notification.propTypes = {
  id: PropTypes.string.isRequired,
  dismissable: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
  target: PropTypes.string,
  messageDescription: PropTypes.object,
  messageValue: PropTypes.object,
  link: PropTypes.string,
  linkTextDescription: PropTypes.object,
  linkTextValue: PropTypes.object,
  handleOnClick: PropTypes.func,
};

export default injectIntl(Notification);



// WEBPACK FOOTER //
// ./components/notifications/notification.js